import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavTabService } from '../../../../services/nav-tab.service';
import { RmsModule } from '../../../../custom-modules/rms-module/rms.module'
import { QuickLinkService } from '../../../../services/quick-links.service';
import html2pdf from 'html2pdf.js';
import { InventoryFormComponent } from '../../../../components/CoffeeComponents/inventory/purchase-orders/inventory-form/inventory-form.component'

@Component({
  selector: 'app-quick-link-new-po',
  imports: [RmsModule],
  templateUrl: './quick-link-new-po.component.html',
  styleUrl: './quick-link-new-po.component.scss'
})
export class QuickLinkNewPoComponent {
  @ViewChild('pdfContainer') pdfContainerRef!: ElementRef;
  PrintPOPDF = false;
  inventoryFormComponentType = InventoryFormComponent;
  constructor(private navTab: NavTabService, private quickLinkService: QuickLinkService) { }
  onCancel() {
    this.quickLinkService.triggerClose();
  }
  onNewPO() {
    const navItem = this.navTab.getNavItemFromTitle("Purchase Orders");
    if (navItem) {
      this.navTab.addTab({ title: navItem.title, icon: navItem.icon, componentKey: navItem?.componentKey, data: { NewPurchaseOrder: true } })
      this.quickLinkService.triggerClose();
    }
  }
  onNewMultiPO() {
    const navItem = this.navTab.getNavItemFromTitle("Purchase Orders");
    if (navItem) {
      this.navTab.addTab({ title: navItem.title, icon: navItem.icon, componentKey: navItem?.componentKey, data: { MultiPurchaseOrder: true } })
      this.quickLinkService.triggerClose();
    }
  }
  generatePdf() {
    this.PrintPOPDF = true;

    setTimeout(() => {
      const pdfElement = this.pdfContainerRef.nativeElement;

      const opt = {         // inches: top/bottom, left/right
        filename: 'InventoryForm.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
      };
      html2pdf().set(opt).from(pdfElement).save().then(() => {
        this.PrintPOPDF = false;
        this.quickLinkService.triggerClose();
      })
    }, 300);
  }
}
